import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { MANAGER_PROFILE } from "../config/lang";
import { logout } from "../util/redux/actions";
import { translate } from "../util/util";

export default function HeaderAvatar() {
  const { me } = useSelector(state => state);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [imgError, setImgError] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const callLogout = () => {
    dispatch(logout());
  };

  const initials =
    me?.first_name && me?.last_name
      ? `${me.first_name[0]}${me.last_name[0]}`.toUpperCase()
      : me?.first_name
      ? me.first_name[0].toUpperCase()
      : "?";

  const fullName = `${me?.first_name || ""} ${me?.last_name || ""}`.trim();

  const roleLabel =
    me?.role === "supervisor_manager"
      ? "Supervisor Manager"
      : me?.role === "supervisor"
      ? "Supervisor"
      : me?.role || "";

  const avatarNode = () => {
    if (me?.photo && !imgError) {
      return <img src={me.photo} alt={fullName} onError={() => setImgError(true)} />;
    }
    return <span className="md-nav-icon md-avatar-icon">person</span>;
  };

  return (
    <div className="md-header-user" ref={ref} onClick={() => setOpen(v => !v)}>
      <div className="md-avatar">
        {avatarNode()}
      </div>
      <span className="md-avatar-name">{fullName}</span>
      <span className="md-nav-icon" style={{ fontSize: "18px", color: "var(--md-on-surface-variant)" }}>
        {open ? "expand_less" : "expand_more"}
      </span>

      {open && (
        <div className="md-user-dropdown" onClick={e => e.stopPropagation()}>
          <div className="md-dropdown-user-header">
            <div className="md-avatar md-avatar--lg">
              {avatarNode()}
            </div>
            <div className="md-dropdown-user-info">
              <div className="md-dropdown-user-name">{fullName}</div>
              <div className="md-dropdown-user-role">{roleLabel}</div>
            </div>
          </div>

          <div className="md-dropdown-divider" />

          <Link
            className="md-dropdown-item"
            to="/profile"
            onClick={() => setOpen(false)}
          >
            <span className="md-nav-icon">manage_accounts</span>
            {translate(MANAGER_PROFILE, "my_profile", me?.language)}
          </Link>

          <div className="md-dropdown-divider" />

          <button className="md-dropdown-item md-dropdown-item--danger" onClick={callLogout}>
            <span className="md-nav-icon">logout</span>
            {translate(MANAGER_PROFILE, "exit", me?.language)}
          </button>
        </div>
      )}
    </div>
  );
}
